import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, MenuItem, FormControl, InputLabel, Select
} from '@mui/material';

const roles = ['Super Admin', 'Admin', 'User']; // customize roles as needed

const CreateUserDialog = ({ openCreateUserDialog, onCloseCreateUserDialog, onCreateUserDialogClick }) => {
    
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [password, setPassword] = useState('nexIntain@123');

    const isFormValid = email.trim() !== '' && role.trim() !== '';

    const handleCreate = () => {
        const newUser = { email, password, role };
        onCreateUserDialogClick(newUser);
        handleClose();
    };

    const handleClose = () => {
        setEmail('');
        setRole('');
        setPassword('nexIntain@123');
        onCloseCreateUserDialog();
    };

    return (
        <Dialog open={openCreateUserDialog} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Create User</DialogTitle>
            <DialogContent dividers>
                <TextField
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                />
                <TextField
                    label="Password (optional)"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <FormControl fullWidth margin="normal" required>
                    <InputLabel>Role</InputLabel>
                    <Select
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        label="Role"
                    >
                        {roles.map((r) => (
                            <MenuItem key={r} value={r}>{r}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button 
                onClick={handleClose}
                sx={{ height: 35, backgroundColor: 'grey', color: 'white', fontSize: 13,}}
                >
                    Cancel
                </Button>
                <Button 
                onClick={handleCreate} 
                disabled={!isFormValid} 
                variant="contained"
                sx={{ height: 35, color: 'black', fontSize: 13,}}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateUserDialog;
